module.exports = __webpack_public_path__ + "img/company_3.e832a4db.jpg";